import { FacilitiesResponse } from './types';
import { getLocationsFormatted, getNearestFacility, getNearestOpenFacility } from './utils';

export const normalizedFacilities = (facilities: FacilitiesResponse) => {
  const {
    emergencyRoomsLocations,
    instacaresLocations,
    kidscaresLocations
  } = getLocationsFormatted(facilities);

  const { nearestEmergencyRoom, nearestInstacare, nearestKidscare } = getNearestFacility({
    emergencyRoomsLocations,
    instacaresLocations,
    kidscaresLocations
  });

  const {
    nearestOpenEmergencyRoom,
    nearestOpenInstacare,
    nearestOpenKidscare
  } = getNearestOpenFacility({
    emergencyRoomsLocations,
    instacaresLocations,
    kidscaresLocations
  });

  return {
    instacares: instacaresLocations,
    kidscares: kidscaresLocations,
    emergencyRooms: emergencyRoomsLocations,
    nearestEmergencyRoom,
    nearestInstacare,
    nearestKidscare,
    nearestOpenEmergencyRoom,
    nearestOpenInstacare,
    nearestOpenKidscare
  };
};
